var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('MainSlider'),_c('div',{staticClass:"wrapper"},[_c('ProductSlider'),_c('GreenBanner'),_c('NewProduct'),_c('NoticeList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }